<div class="flex flex-col gap-6 pr-5 pb-10 pl-5">
  <div class="flex flex-col items-start gap-1">
    <h1 class="textPrimaryColor text-2xl font-bold" i18n="@@statementAccountTitle">كشف الحساب</h1>
  </div>

  <app-account-statement-filter (applyFilters)="onApplyFilters($event)" (resetFilters)="onResetFilters()" />

  <div class="flex flex-wrap items-stretch justify-start gap-4">
    @if (selectedPharmacy(); as pharmacy) {
      <div
        class="flex max-w-[380px] min-w-[320px] items-center justify-between gap-8 rounded-[14px] border border-gray-200 bg-white px-5 py-3.5 shadow-sm">
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-1.5">
            <app-pharmacy-snack-icon />
            <span class="GreyTextColor text-[14px] font-semibold">{{ pharmacy.pharmacyName }}</span>
          </div>
          <div class="flex items-center gap-1.5">
            <app-location-icon />
            <span class="text-[12px] text-gray-400">{{ pharmacy.location }}</span>
          </div>
        </div>
        <div class="flex flex-col items-end gap-2">
          <div class="flex items-center gap-1.5">
            <app-human-icon />
            <span class="GreyTextColor text-[13px]">{{ pharmacy.ownerName }}</span>
          </div>
          <div class="flex items-center gap-1.5">
            <app-id-hash-icon />
            <span class="text-[12px] text-gray-400">{{ pharmacy.pharmacyId }}</span>
          </div>
        </div>
      </div>
    }

    <div
      class="flex max-w-[360px] min-w-[300px] items-center justify-between gap-2 rounded-[14px] border border-gray-200 bg-white px-6 py-3.5 shadow-sm">
      <div class="flex min-w-[70px] flex-col items-center gap-1">
        <span class="text-[12px] font-medium text-gray-400" i18n="@@totalInvoicesCard">عدد الفواتير</span>
        <span class="GreyTextColor text-[18px] font-bold">{{ statistics().total }}</span>
      </div>
      <div class="h-8 w-px shrink-0 bg-gray-200"></div>
      <div class="flex min-w-[70px] flex-col items-center gap-1">
        <span class="text-[12px] font-medium text-gray-400" i18n="@@unpaidInvoicesCard">الغير مدفوعة</span>
        <span class="GreyTextColor text-[18px] font-bold">{{ statistics().unpaid }}</span>
      </div>
      <div class="h-8 w-px shrink-0 bg-gray-200"></div>
      <div class="flex min-w-[70px] flex-col items-center gap-1">
        <span class="text-[12px] font-medium text-gray-400" i18n="@@partiallyPaidInvoicesCard">المدفوعة جزئياً</span>
        <span class="GreyTextColor text-[18px] font-bold">{{ statistics().partiallyPaid }}</span>
      </div>
    </div>
  </div>

  @if (state() === "loading") {
    <app-loading />
  }

  @if (state() === "error") {
    <app-error-data title="Something went wrong" [showRetry]="true" (retry)="loadData()" />
  }

  @if (state() === "success") {
    <app-tables
      [headerItems]="tableHeaderData()"
      [rows]="rows()"
      (toggleDropdown)="toggleDropdown($event)"
      [currentActions]="currentActions()"
      (actionTrigger)="handleAction($any($event))"
      [isFiltersApplied]="isFiltersApplied()"
      [emptyFilterTitle]="'لا توجد فواتير مطابقة لمعايير البحث المحددة.'"
      [emptyContentTitle]="'لا توجد فواتير مستحقة'"
      [emptyContentDescription]="'لا توجد فواتير مستحقة لهذه الصيدلية.'" />

    @if (totalItems() > 0) {
      <app-pagination
        [itemsPerPage]="itemsPerPage()"
        [currentPage]="currentPage()"
        [getPageNumbers]="pageNumbers()"
        [totalPages]="totalPages()"
        [startItem]="startItem()"
        [endItem]="endItem()"
        [totalItems]="totalItems()"
        (previousPage)="onPreviousPage()"
        (nextPage)="onNextPage()"
        (goToPage)="onGoToPage($event)"
        (changePageNumber)="onChangePageNumber($event)"
        (pageSizeChange)="onPageSizeChange()" />
    }
  }
</div>
